/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme, alpha } from '@mui/material/styles';
import { PROMETHEAN_PURPLE_PLUM, PROMETHEAN_BLUE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_TEXT, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_DARK_PURPLE } from '../../../styles/colors/colors';
export var refreshButtonTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          '&.EmbersRefreshButton-root': {
            minWidth: '56px',
            width: '56px',
            padding: '3px 15px',
            borderRadius: '100px',
            color: PROMETHEAN_TEXT,
            border: "1px solid ".concat(PROMETHEAN_PURPLE_PLUM),
            background: PROMETHEAN_NEUTRAL_WHITE,
            '&:hover': {
              background: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1)
            },
            '&:active': {
              background: alpha(PROMETHEAN_DARK_PURPLE, 0.2)
            },
            '&.Mui-focusVisible': {
              border: "2px solid ".concat(PROMETHEAN_BLUE),
              padding: '2px 14px',
              background: alpha(PROMETHEAN_PURPLE_GRAPE, 0.1)
            },
            '&.Mui-disabled': {
              color: PROMETHEAN_NEUTRAL_DARK_GREY,
              borderColor: PROMETHEAN_NEUTRAL_DARK_GREY,
              background: PROMETHEAN_NEUTRAL_WHITE,
              cursor: 'not-allowed',
              pointerEvents: 'all'
            }
          }
        }
      }
    }
  }
});